import { Pipe, PipeTransform } from '@angular/core';
import { StatusWorkflowTypeItem } from 'src/app/api/models';
import { enumDeliveryAdditionalService } from '../enums/addl_services_enum.enum';

@Pipe({
  name: 'additionalServicePipe',
})
export class AdditionalServicePipe implements PipeTransform {
  transform(value: number): string {
    switch (value) {
      case enumDeliveryAdditionalService.CONSEGNA_AL_PIANO:
        return 'Consegna al piano';
      case enumDeliveryAdditionalService.PREAVVISO_TELEFONICO:
        return 'Preavviso telefonico';
      default:
        return 'Unknown Type';
    }
  }
}
